import Vue from 'vue'
import VueRouter from 'vue-router';
import store from "@/store";

Vue.use(VueRouter)

/* Preuntar si rol actual permite pasar */
export function checkRoleValue(currentRole,rolePermission){

  let clientRoles = ["Gratis","Individual","Dueno","Vendedor"]
  let role = clientRoles.indexOf(currentRole) > -1 ? "cliente" : "admin";
  return role == rolePermission ? true : false;
}

const routes = [
  /* Ruta no encontrada */
  {
    path: "*",
    component: ()=> import("@/components/errors/404.vue") ,
    name: 'pageNotFound'
  },
  /* Rutas sin autenticar */
  {
    path: '/',
    redirect: '/ingresar'
  },
  /* Auth cliente */
  {
    path: '/ingresar',
    component: () => import('@/views/Auth/Login.vue'),
    name:'login'
  },
  {
    path: '/registro',
    component: () => import('@/views/Auth/Register.vue'),
    name:"clientRegister"
  },
  {
    path: '/olvide/contraseña',
    component: () => import('@/views/Auth/ForgotPassword.vue'),
    name:'clientForgotPassword'
  },
  {
    path: '/password/restablecer/cliente',
    component: () => import('@/views/Auth/ResetPassword.vue'),
    name:'clientResetPassword'
  },
  {
    path: '/verificar/correo/:token',
    component: () => import('@/views/Auth/email_verification/EmailVerify.vue'),
    name:'clientVerifyEmail'
  },
  {
    path: '/reenviar/correo',
    component: () => import('@/views/Auth/email_verification/EmailResendMail.vue'),
    name:'clientResendEmail'
  },
  /* Auth admin */
  {
    path: '/ingresar/admin',
    component: () => import('@/views/Admin/LoginAdmin.vue'),
    name:'loginAdmin'
  },
  {
    path: '/olvide/contraseña/admin',
    component: () => import('@/views/Admin/ForgotPassword.vue'),
    name:'adminForgotPassword'
  },

  {
    path: '/password/restablecer/admin',
    component: () => import('@/views/Admin/ResetPassword.vue'),
    name:'adminResetPassword'
  },



  /* Vistas de errores  */
  {
    path: '/errors/401',
    component: () => import('@/components/errors/401.vue'),
    meta: { requiresAuth: true },
  },
  /* System design */
  {
    path: '/system_design',
    component: () => import('@/views/SystemDesign.vue'),
    meta: { requiresAuth: true },
  },
  /* Rutas abiertas para que cliente vea cotizaciones */
  {
    path: '/cotizaciones/cliente/detalle',
    component: () => import('@/views/cotizacion/ClienteDetail.vue'),
    props: true,
    name:'clientDetail'
  },
  {
    path: '/cotizaciones/cliente/detalle/editando',
    component: () => import('@/components/cotizacion/helpers/QuoteStatusEdit'),
    props: true,
    name:'clientQuoteNotAvailable'
  },
  {
    path: '/cotizaciones/cliente/detalle/not_found',
    component: () => import('@/components/cotizacion/helpers/QuoteNotFound'),
    props: true,
    name:'clientQuoteNotFound'
  },

  /* Meta cliente */
  {
    path: '/dashboard',
    component: () => import('@/views/Template.vue'),
    children: [
      {
        path: '/',
        component: () => import('@/views/Dashboard.vue'),
        meta: { requiresAuth: true, role:'cliente',permission: ['list_quotattions']},
        name:"clientDashboard"
      },
      {
        path: '/aceptar/invitacion',
        component: () => import('@/views/TeamInvitation.vue'),
        meta: { requiresAuth: true, role:'cliente'},
        name:"clientInvitation"
      },
      {
        path: '/estadisticas',
        component: () => import('@/views/Statistics.vue'),
        meta: { requiresAuth: true, role:'cliente',permission: ['statistics']},
        name:'clientStatistics'
      },
      {
        path: '/cotizaciones',
        component: () => import('@/views/Quotes.vue'),
        children: [
          {
            path: 'enviar/:quoteId',
            component: () => import('@/components/quotes/Send.vue'),
            meta: { requiresAuth: true, role:'cliente',permission: ['send_quotation']},
            name:'clientSendQuote'
          },
          {
            path: 'plantilla',
            component: () => import('@/components/cotizacion/Template.vue'),
            meta: { requiresAuth: true, role:'cliente',permission: ['create_quotation_template']},
            name:'clientCreateTemplate'
          },
          {
            path: 'plantilla/editar/:quoteTemplateId',
            component: () => import('@/components/cotizacion/TemplateEdit.vue'),
            meta: { requiresAuth: true, role:'cliente',permission: ['create_quotation_template']},
            name:'clientEditTemplate'
          },
          {
            path: 'nueva',
            component: () => import('@/components/cotizacion/new.vue'),
            meta: { requiresAuth: true, role:'cliente',permission: ['create_quotation']},
            name:'clientNewQuotation'
          },

          {
            path: 'detalle/:quoteId',
            component: () => import('@/components/cotizacion/edit.vue'),
            meta: { requiresAuth: true, role:'cliente',permission: ['create_quotation']},
            name:'clientEditQuotation'
          },
          {
            path: 'owner/detalle/:quoteId',
            component: () => import('@/views/cotizacion/OwnerDetail.vue'),
            meta: { requiresAuth: true, role:'cliente',permission: ['detail_quotation']},
            name:'clientOwnerQuoteDetail'
          },
          {
            path: 'owner/preview/:quoteId',
            component: () => import('@/views/cotizacion/OwnerPreview.vue'),
            meta: { requiresAuth: true, role:'cliente',permission: ['preview_quotation']},
            name:'clientOwnerQuotePreview'
          },
        ]
      },
      {
        path: '/clientes',
        component: () => import('@/views/clients/Clients.vue'),
        children: [
          {
            path: '/',
            component: () => import('@/components/clients/ClientsDashboard.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['view_clients']},
            name:'clientContactsDashboard'
          },
          {
            path: 'empresa/crear',
            component: () => import('@/components/clients/Company.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['add_company']},
            name:'clientCreateCompany'
          },
          {
            path: 'empresa/editar/:empresaId',
            component: () => import('@/components/clients/EditCompany.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['add_company']},
            name:'clientEditCompany'
          },
          {
            path: 'contacto/crear',
            component: () => import('@/components/clients/Contact.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['add_contact']},
            name:'clientCreateContact'
          },
          {
            path: 'contacto/editar/:contactId',
            component: () => import('@/components/clients/EditContact.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['add_contact']},
            name:'clientEditContact'
          },
        ]
      },
      {
        path: '/items',
        component: () => import('@/views/Items.vue'),
        children: [
          {
            path: '/',
            component: () => import('@/components/items/Table.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['view_templates']},
            name:'clientItemsDashboard'
          },
          {
            path: 'crear/producto',
            component: () => import('@/components/plantilla/ProductItem.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['create_product_template']}
          },
          {
            path: 'editar/producto/:productId',
            component: () => import('@/views/plantilla/EditProduct.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['create_product_template']}
          },
          {
            path: 'crear/texto',
            component: () => import('@/components/plantilla/TextItem.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['create_text_template']}
          },
          {
            path: 'editar/texto/:textId',
            component: () => import('@/views/plantilla/EditText.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['create_text_template']}
          },

        ]
      },
      {
        path: '/configuracion',
        component: () => import('@/views/Settings.vue'),
        children: [
          {
            path: '/',
            component: () => import('@/components/settings/Menu.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['general_settings']},
            name:"clientConfigMenu"
          },
          {
            path: 'formato',
            component: () => import('@/components/settings/Design.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['modify_style']},
            name:"clientConfigDesign"
          },
          {
            path: 'informacion',
            component: () => import('@/components/settings/Company.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['edit_company']},
            name:"clientConfigCompany"
          },
          {
            path: 'valores',
            component: () => import('@/components/settings/Values.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['default_values']},
            name:"clientConfigDefaultValues"
          },
          {
            path: 'emails',
            component: () => import('@/components/settings/Emails.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['edit_setting_email']},
            name:"clientConfigEmails"
          },
          {
            path: 'remitente',
            component: () => import('@/components/settings/Remitent.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['edit_setting_email']},
            name:"clientConfigRemitent"
          },
          {
            path: 'pagos',
            component: () => import('@/components/settings/Payments.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['change_plan']},
            name:"clientConfigPayments"
          },
          {
            path: 'exportar',
            component: () => import('@/components/settings/Export.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['export_quotation']},
            name:"clientConfigExportQuotes"
          },
          {
            path: 'referidos',
            component: () => import('@/components/settings/Referral.vue'),
            meta: { requiresAuth: true, role:'cliente'},
            name:"clientConfigReferal"
          },
          {
            path: 'equipo',
            component: () => import('@/components/settings/Members.vue'),
            meta: { requiresAuth: true, role:'cliente',permission:['edit_company']},
            name:"clientConfigTeam"
          },
          {
            path: 'cuenta',
            component: () => import('@/components/settings/EditUser.vue'),
            meta: { requiresAuth: true, role:'cliente', permission:['manage_account']},
            name:"clientConfigAccount"
          },
        ]
      },
    ]
  },

  /* Meta admin */
  {
    path: '/admin',
    component: () => import('@/views/Admin/AdminTemplate.vue'),
    children:[
      {
        path: '/',
        component: () => import('@/views/Admin/DashboardAdmin.vue'),
        meta: { requiresAuth: true, role:'admin' },
        name:'adminDashboard'
      },
      {
        path: 'user/:userId',
        component: () => import('@/views/Admin/user/User.vue'),
        meta: { requiresAuth: true, role:'admin' },
        name:'userProfileAdmin'
      },
      {
        path:'crear/usuario',
        component: () => import('@/views/Admin/user/NewUser.vue'),
        meta: { requiresAuth: true, role:'admin' },
        name:'adminNewUser'
      },
      {
        path: 'configuracion',
        component: () => import('@/views/Admin/configuration/Configuration.vue'),
        meta: { requiresAuth: true, role:'admin' },
        name:'configAdmin',
      },
      {
        path: 'configuracion/emails',
        component: () => import('@/components/admin/settings/Emails.vue'),
        meta: { requiresAuth: true, role:'admin' },
        name:'configEmails',
      }
      ,
      {
        path: 'configuracion/valores',
        component: () => import('@/components/admin/settings/Values.vue'),
        meta: { requiresAuth: true, role:'admin' },
      }
      ,
      {
        path: 'configuracion/informacion',
        component: () => import('@/components/admin/settings/InfoAccount.vue'),
        meta: { requiresAuth: true, role:'admin' },
      },
      {
        path: 'configuracion/equipo',
        component: () => import('@/components/admin/settings/Team.vue'),
        meta: { requiresAuth: true, role:'admin' },
      },
      {
        path: 'configuracion/exportar/clientes',
        component: () => import('@/components/admin/settings/ExportClients.vue'),
        meta: { requiresAuth: true, role:'admin' },
        name:"adminExportClients"
      },
    ]
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

const exceptedRoutes = ['clientQuoteNotFound','clientQuoteNotAvailable','clientDetail','pageNotFound']

router.beforeEach((to, from, next) => {

  /* Pregunta si la ruta a la que se quiere entrar necesita autenticacion */
  if(to.matched.some(path => path.meta.requiresAuth)){
    /* Se pregunta si el usuario esta loggeado */
    if(store.getters.isLoggedIn){
      /* Si la ruta tiene definido un rol */
      if(to.meta.role){
        /* Preguntar si es que el rol del usuario coincide con el requerido por la ruta*/
        if(checkRoleValue(store.getters.userRole,to.meta.role)){
          /* Preguntar si la ruta tiene algun permiso en especifico */
          if(to.matched.some(path => path.meta.permission)){
            /* Se el permiso necesario de la ruta esta en los permisos dejar pasar */
            if(store.getters.permissions.indexOf(to.meta.permission[0]) > -1){
              next();
            }else{
              next({ path: '/errors/401' })
            }
          }else{
            next();
          }
        }else{
          if(to.meta.role == 'cliente'){
            next({ name: 'clientDashboard' })
          }else{
            if(to.meta.role == 'admin'){
              next({ name: 'adminDashboard' })
            }
          }
        }
      }else{
        next();
      }
    }else{
      /* En caso de que la validacion de que no este loggeado falle se regresa a la pantalla de login */
      next({ path: '/ingresar' })
      if(to.name == "clientInvitation"){
        localStorage.setItem("tokenInvitation", to.query.token)
        next({ path: '/registro'})
      }else{
        next({ path: '/ingresar' })
      }
    }
  }else{

    /* Seccion en caso de que la ruta no requiera autenticacion preguntar si el usuario esta loggeado*/
    if(store.getters.isLoggedIn){
      if(exceptedRoutes.indexOf(to.name) > -1){
        next();
      }else{
        if(to.meta.role == 'cliente'){
          next({ name: 'adminDashboard' })
        }else{
          if(to.meta.role == 'admin'){
            next({ name: 'clientDashboard' })
          }else{
            /* No tiene roles  */
            next({ name: 'clientDashboard' })
          }
        }
      }
    }else{
      next();
    }
  }
})

export default router
